import {BaseApi, RequireAuthApi} from '@/api/base.api';
import {TaskModel} from '@/models/task.model';
import {Observable} from 'rxjs';
import {axiosInstanceAuthenticated} from '@/api/axios.config.api';
import {map} from 'rxjs/operators';

export class TaskApi extends BaseApi<TaskModel> {

  constructor(protected challengeId: number) {
    super(`challenges/${challengeId}/tasks`, [
      RequireAuthApi.UPDATE,
      RequireAuthApi.DESTROY,
      RequireAuthApi.CREATE,
    ]);
  }

  join(taskId: number): Observable<TaskModel> {
    return axiosInstanceAuthenticated().post(`${this.url}/${taskId}/join`)
      .pipe(map((response) => response.data))
  }

  abort(taskId: number): Observable<TaskModel> {
    return axiosInstanceAuthenticated().post(`${this.url}/${taskId}/abort`)
      .pipe(map((response) => response.data))
  }
}
